import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TrainingTabConstants } from './constants/training-tab.constants';
import { TrainingPlanDto } from '../../models/trainingPlan/trainingPlanDto';
import { CourseService } from '../../../course/services/course.service';
import { AuthenticationHelperService } from '../authentication-maintainance/services/authentication-helper.service';
import { MessageService } from 'primeng/api';
import { CourseConstants } from '../../../course/constants/course.constants';

@Component({
  selector: 'app-training-tab',
  templateUrl: './training-tab.component.html',
  styleUrls: ['./training-tab.component.scss']
})
export class TrainingTabComponent implements OnInit {
    constructor(private courseService: CourseService, private messageService: MessageService,
        private readonly authenticationHelperService: AuthenticationHelperService, private cd: ChangeDetectorRef

  ) { }
  @Input() showQuiz: boolean = false;
  @Input() trainingPlanDto?: TrainingPlanDto
  @Input() confirmationMessage!: string;
  @Input() buttonLabel!:string;
  @Input() displayQuizCompletionBtn!:string;
  @Input() courseDetail?: any;
  @Input() disabled?: boolean;
  @Input() quizDataToDisplay?: any;
  @Input() quizType!:any;
  @Input() trainingItemGroupVisible: boolean = true;
  @Output() update = new EventEmitter<Event>();
  @Output() reload = new EventEmitter<Event>();
  ifButtonIsClicked: boolean = false;
  coreCurriculumColumnName: string = TrainingTabConstants.ColumnName_CoreCurriculum;
  electiveCurriculumColumnName: string = TrainingTabConstants.ColumnName_ElectiveCurriculum;
  trainingItemGroupsLabel: string = TrainingTabConstants.TrainingItemGroups_Label;


  ngOnInit(): void {}

  openConfirmationModal(){
    if (
      this.courseDetail?.prerequisites?.length > 0 &&
      this.courseDetail.format === CourseConstants.course_Format_SelfStudy_Value
    ) {      
      // Check prerequisites before calling the API
      this.courseService.verifyPrerequisitesTrainingStatus(this.courseDetail.prerequisites)
        .subscribe({
          next: (response) => {
            // If the response is 200 , will call update training or open Quiz service call
            this.ifButtonIsClicked = true;
          },
          error: (error) => {
            // If the response is 412, displaying and custom error toaster
            if (error.status === 412) {
              this.display412ValidationError();
            } else {
              this.handleOtherErrors(error);
            }
          }
        });
    } else {
      // No prerequisites or If its Documemt training tab then directly get the quiz details
      this.ifButtonIsClicked = true;
    }
  }

  closeConfirmationModal(){
    this.ifButtonIsClicked = false;
    this.cd.detectChanges();
  }

  updateTrainingPlan(){  
    this.closeConfirmationModal();
    if (this.quizDataToDisplay != null) {
      this.showQuiz = true;
    } else {
      this.update.emit();
    }
    this.ifButtonIsClicked = false;
  }

  onConfirm(){
    this.authenticationHelperService.reauth(this.updateTrainingPlan.bind(this), this.closeConfirmationModal.bind(this));
  }

  reloadTraining() {
    this.reload.emit();
  }

  disableTakeQuiz(event: any) {
    this.disabled = event;
  }

  closeQuiz($event:any)  {
    this.showQuiz=false;
    this.cd.detectChanges();
  }  

  private display412ValidationError() {
    this.messageService.add({
      severity: CourseConstants.Severity_Error,
      summary: CourseConstants.CourseTraining_Complete_Validation,
      sticky: true
    });
  }
  
  private handleOtherErrors(error: any) {
    // Handlin apI errors
    this.messageService.add({
      severity: CourseConstants.Severity_Error,
      summary: CourseConstants.CourseApi_Error_Message
    });
  }
}


